var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10348 2.37936C2.31618 2.01627 2.78672 1.89216 3.15447 2.10217L5.96228 3.70561L8.96755 15.9244C10.1055 15.9403 11.094 16.5661 11.6128 17.4857L21.0368 15.0628C21.4479 14.9571 21.8679 15.2005 21.975 15.6064C22.082 16.0123 21.8355 16.427 21.4244 16.5327L12 18.9558V18.962C12 20.6399 10.6224 22 8.9231 22C7.22379 22 5.84622 20.6399 5.84622 18.962C5.84622 17.8022 6.50456 16.7941 7.47242 16.2823L4.62254 4.69528L2.38422 3.41706C2.01648 3.20705 1.89078 2.74246 2.10348 2.37936Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05345 6.36336C7.90701 5.82376 8.23184 5.26898 8.77898 5.12423L17.6951 2.76539C18.2422 2.62064 18.8045 2.94073 18.9509 3.48033L19.2161 4.45737C19.3615 4.99331 19.042 5.54422 18.5016 5.6935L20.0956 11.5669C20.242 12.1065 19.9172 12.6612 19.37 12.806L12.4353 14.6406C11.8882 14.7854 11.3259 14.4653 11.1795 13.9257L9.58555 8.05239L9.57443 8.05534C9.02729 8.20009 8.46504 7.88 8.3186 7.3404L8.05345 6.36336Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxCart);
export default __webpack_public_path__ + "static/media/box-cart.4c6df80add0cec80d6e5cf2dc24dad20.svg";
export { ForwardRef as ReactComponent };